import React, { useState } from "react";
import { ICONS } from "../../helpers/helper";

const CollapseList = (props) => {
  
  const [isCollapsed, setIsCollapsed] = useState(props.isCollapsed || false)

  const { items, selectedItems = [], onChange, title, isMulti = false, isForced = false } = props;

  const handleSelectTag = (tag) => {
    let newTags = [...selectedItems];
    if (selectedItems.indexOf(tag.value) < 0) {
      newTags = isMulti ? [...selectedItems, tag.value] : [tag.value];
    } else if(!isForced) {
      newTags = selectedItems.filter((t) => t !== tag.value);
    }
    onChange([...newTags]);
  };

  if(!items || items.length === 0) return null;

  return (
    <div className={`cbmap-collapse cbmap-filter-box ${isCollapsed ? 'cbmap-collapsed' : 'cbmap-shown'}`}>
      <div 
        className="cbmap-collapse-heading"
        onClick={e => setIsCollapsed(!isCollapsed)}
      >
        {title || 'Filters'}
        <button
          className="cbmap-collapse-handler"
          dangerouslySetInnerHTML={{__html: ICONS.CARET}}
          onClick={e => setIsCollapsed(!isCollapsed)}
        />
      </div>
      <div className={`cbmap-collapse-inner`}>
          {items.map((tag, idx) => (
          <div
            key={`${idx}-${tag.label}`}
            className={`cbmap-line-selector ${
              selectedItems.indexOf(tag.value) >= 0 ? "is-selected" : ""
            }`}
            onClick={(e) => handleSelectTag(tag)}
          >
            {tag.label}
            <span className="cbmap-icon-checked" dangerouslySetInnerHTML={{__html: ICONS.CHECKED}}>
            </span>
          </div>
        ))}
      </div>
      
    </div>
  );
};

export default CollapseList;
